var map = {
	"./App.vue": 566,
	"./assets/logo.png": 6949,
	"./i18n/en-US.js": 1747,
	"./i18n/zh-CN.js": 1831,
	"./main.js": 1095,
	"./pages/api/index.vue": 7518,
	"./pages/api/route.js": 2654,
	"./pages/frame/index.vue": 5483,
	"./pages/frame/route.js": 9265,
	"./pages/preview/index.vue": 3226,
	"./pages/preview/route.js": 1567,
	"./pages/visual/index.vue": 6428,
	"./pages/visual/route.js": 4016,
	"./registry/api.js": 7183,
	"./registry/host.js": 5700,
	"./registry/mixin.js": 7756,
	"./registry/route.js": 1304,
	"./registry/store.js": 553,
	"./styles/index.less": 1138,
	"./utils/foreach.js": 1687,
	"./utils/qs.js": 5050,
	"./variables.module.less": 2578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8678;